import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Nav, Footer } from './components/Chrome';
import Home from './pages/Home';
import MenuPage from './pages/MenuPage';
import About from './pages/About';
import Visit from './pages/Visit';
import BestIndianRestaurantIrvingTx from './pages/blog/BestIndianRestaurantIrvingTx';
import BestIndianRestaurantIrvingLasColinas from './pages/blog/BestIndianRestaurantIrvingLasColinas';
import BiryaniVsPulavVsMandi from './pages/blog/BiryaniVsPulavVsMandi';
import BestRestaurantsIrvingTxOpenNow from './pages/blog/BestRestaurantsIrvingTxOpenNow';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="wrap min-h-[70vh] grid place-items-center text-center pt-32">
      <div>
        <p className="eyebrow">404</p>
        <h1 className="font-display mt-3 text-ink" style={{ fontSize: 'clamp(2.2rem, 6vw, 3.6rem)' }}>
          This page went off the menu.
        </h1>
        <p className="mt-4 text-ink-2">Let’s get you back to the good stuff.</p>
        <div className="mt-7 flex justify-center gap-3">
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/menu" className="btn btn-ghost">See the menu</Link>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/blog/best-indian-restaurant-irving-tx" element={<BestIndianRestaurantIrvingTx />} />
            <Route path="/blog/best-indian-restaurant-irving-las-colinas" element={<BestIndianRestaurantIrvingLasColinas />} />
            <Route path="/blog/biryani-vs-pulav-vs-mandi" element={<BiryaniVsPulavVsMandi />} />
            <Route path="/blog/best-restaurants-irving-tx-open-now" element={<BestRestaurantsIrvingTxOpenNow />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
  );
}


/* injected: entrance-visibility failsafe — content must never stay invisible */
if (typeof window !== 'undefined') {
  var __hsReveal = function(){
    try {
      document.querySelectorAll('.reveal,.fade-in,.fade-up,[data-reveal],[data-aos]').forEach(function(el){ el.classList.add('in','visible','revealed','active','aos-animate'); });
      document.querySelectorAll('*').forEach(function(el){
        // Skip intentionally-hidden overlays (cart drawer / mobile nav scrim use
        // opacity-0 + pointer-events-none as their closed state, not a stuck reveal).
        if (el.classList && el.classList.contains('pointer-events-none')) return;
        var cs = getComputedStyle(el);
        if (parseFloat(cs.opacity) < 0.05 && el.getClientRects().length) {
          el.style.setProperty('opacity','1','important');
          if (cs.transform && cs.transform !== 'none') el.style.setProperty('transform','none','important');
        }
      });
    } catch(e){}
  };
  window.addEventListener('load', function(){ setTimeout(__hsReveal, 1500); setTimeout(__hsReveal, 3500); });
}
